








































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { shortenString } from '@/shared/utils/shorten-string'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'
import { format } from 'date-fns'
import { de } from 'date-fns/locale'
import { OfferEvent } from '@/api/generated'
import { ProjectOfferLite } from '@/business/home/store/konstanz-home-state'

@Component({
  components: { RespondecoResponsiveImage },
})
export default class KonstanzOffer extends Vue {
  @Prop({
    type: Object,
  })
  public readonly item!: ProjectOfferLite
  public shortenString = shortenString

  public formatDate(item: OfferEvent): string {
    let date = ''

    if (item.dateFrom && item.dateUntil) {
      date = format(item.dateFrom, 'dd. MMMM yyyy', { locale: de }) + ' '
      date += format(item.dateFrom, 'HH:mm') + ' - '
      date += format(item.dateUntil, 'HH:mm') + ' Uhr'
    }

    return date
  }
}
